import { string } from 'prop-types';
import styled from 'styled-components';
import Spinner from '../StoraEnsoComponents/Spinner';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem 0;
  margin-bottom: 1rem;

  p {
    margin-left: 1rem;
    margin-bottom: 0;
  }
`;

function Loading ({className, message}) {
  return (
    <Wrapper className={className}>
      <Spinner />
      <p>{message}</p>
    </Wrapper>
  );
}

Loading.propTypes = {
  message: string,
  className: string,
}

Loading.defaultProps = {
  message: 'Loading...',
  className: '',
}

export default styled(Loading)``;